export function paywallHubConfig() {
  const wallId = document.getElementById("wallId");
  window.LN.PaywallHub = {
    idWall: wallId?.innerText,
    apiKey: window.config.Constantes.PaywallHubApiKeyToken,
    apiPaywallURL: window.config.Constantes.Dominios.apiPaywallHub,
  };
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/paywallHubConfig.js